import React from "react";

import { OrderReceiveInLabContextProvider } from "./context/order-receive-in-lab--context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class OrdersReceiveInLabPage extends React.Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <OrderReceiveInLabContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </OrderReceiveInLabContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default OrdersReceiveInLabPage;
